import styled, { css } from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'

export const StyledNotificationItemWrapper = styled.div`
  display: grid;
  grid-template-columns: 2.5fr 7fr 1fr;
  border-bottom: 1px solid ${themeStyles.colors.lightGreys[2].main};
  padding: 1rem 0;

  ${({ isUnread }) =>
    isUnread &&
    css`
      background-color: ${themeStyles.colors.white.main};
    `}

  ${({ isExpired }) =>
    !isExpired &&
    css`
      cursor: pointer;
    `}
`

export const StyledNotificationImageBox = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  padding: 0.2rem 0;
  padding-left: 1rem;
  padding-right: 0.3rem;
  box-sizing: border-box;
  position: relative;
  z-index: 0;

  ${({ showBadge }) =>
    showBadge &&
    css`
      &:before {
        content: '';
        position: absolute;
        width: 7px;
        height: 7px;
        border-radius: 100%;
        background-color: ${themeStyles.colors.products.sports.main};
        left: 0.4rem;
        top: 35px;
        z-index: 0;

        ${themeMedia.tablet`
        left: 0.6rem;
      `};
      }
    `}

  img {
    width: 100%;
    max-width: 60px;
    align-self: flex-start;
    position: relative;
    z-index: 0;
    padding: 5px;

    &.is-expired {
      filter: grayscale(1);
    }

    ${themeMedia.tablet`
      max-width: 60px;
    `};
  }
`

export const StyledNotificationCtaBox = styled.button`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background: transparent;

  img {
    flex: 1;
    width: 100%;
    width: 15px;
    height: 14px;

    &.is-unread {
      filter: invert(0.7);
    }
  }
`

export const StyledNotificationContentBox = styled.div``

export const StyledNotificationContentFooter = styled.div`
  display: flex;
  gap: 0.2rem;
  align-items: flex-start;
  margin-top: 0.7rem;
`
